export interface Answer {
  option: string;
  text: string;
}

export interface WorkoutDetails {
  questionId: number;
  title: string;
  question: string;
  answers: Answer[];
  correctAnswer: string;
  answerJustification: string;
}

export enum Status {
  COMPLETED = "Completed",
  IN_PROGRESS = "InProgress",
  NEW = "New",
}

export const getReadableStatus = (status: Status) => {
  if (status === Status.NEW) return "Not Started";
  if (status === Status.IN_PROGRESS) return "In Progress";
};

export interface MxQuickWin {
  quickWin: string;
  id?: number;
}
